import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

// common
import { ROUTES_PATH } from 'layout/constants';

interface NavState {
  from?: string;
  focusOrg?: string;
  tablePage?: number;
  tableRowsPerPage?: number;
}

/**
 * Điều hướng quay lại chức năng Truy xuất thực phẩm (trang Map) kèm state để
 * NewMap mở lại dialog truy xuất. Dùng chung cho nút "Về truy xuất" và việc
 * chặn nút back của trình duyệt, đảm bảo hai đường cùng một hành vi.
 */
export const useTraceabilityBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navState = (location.state || {}) as NavState;
  const fromFoodTraceability = navState.from === 'foodTraceability';

  const goBackToTraceability = useCallback(
    (options?: { replace?: boolean }) => {
      navigate(`/${ROUTES_PATH.portal.index}/${ROUTES_PATH.menuMap.index}`, {
        replace: options?.replace,
        state: {
          reopenFoodTraceability: navState.focusOrg,
          tablePage: navState.tablePage,
          tableRowsPerPage: navState.tableRowsPerPage,
        },
      });
    },
    [navigate, navState.focusOrg, navState.tablePage, navState.tableRowsPerPage]
  );

  return { fromFoodTraceability, goBackToTraceability };
};
